/* eslint-disable react/jsx-fragments */
import React, { Fragment, useCallback } from 'react';
import { connect } from 'react-redux';
import Modal from '../../../common/Modal';
import { showModal, hideModal } from '../../../../actions/modal';
import VideoPlayer from '../VideoPlayer';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';


const VideoAndImageComponent = props => {
  const {
    pagedetails: { banner: { imageUrl = '' } = {}, mobileCatAppUrl = '' } = {},
    showModal,
    hideModal
  } = props;
  const imageClickHandler = useCallback(() => showModal('video-image-modal'), []);
  const closeModal = useCallback(() => hideModal('video-image-modal'), []);
  return (
    <Fragment>
      <Modal name="video-image-modal" className="video-image-modal" show closeButton={false}>
        <VideoPlayer sourceUrl={mobileCatAppUrl} />
        <div className="close-icon">
          <span className="ic-close-quickview" onClick={closeModal} />
        </div>
      </Modal>
      {imageUrl && (
        <div className="video-image">
          <img src={replaceWithJioCDN(imageUrl)} alt="" onClick={imageClickHandler} />
        </div>
      )}
    </Fragment>
  );
};

const mapDispatchToProps = {
  showModal,
  hideModal
};

export default connect(null, mapDispatchToProps)(VideoAndImageComponent);
